/**
 * Represents a recently visited route stored in localStorage.
 * The search parameter stores the actual search object that TanStack Router expects,
 * allowing for direct navigation without parsing.
 */
export type RecentRoute = {
  /** The pathname of the route (e.g., '/assets/unit') */
  pathname: string

  /** The search/query parameters as an object (e.g., { view: 'details' }) */
  search?: Record<string, unknown>

  /** Timestamp when the route was visited */
  timestamp: number

  /** Optional title for the page */
  title?: string
}

/**
 * Represents a page that can be jumped to from the homepage
 * This can be configured at the site level
 */
export type HomepageJumpPages = {
  title: string
  description: string
  pathname: string
  search?: Record<string, unknown>
}

export enum HomepageSearchBarType {
  Default = 'default',
  None = 'none',
  Documents = 'documents',
}

export type HomepageConfigEntry = {
  search_bar_type: HomepageSearchBarType
  landing_page_redirect: string
  show_jump_cards: boolean
  show_recent_activity: boolean
}
